import { render, staticRenderFns } from "./ElementsForms.vue?vue&type=template&id=14db6736&scoped=true"
import script from "./ElementsForms.vue?vue&type=script&lang=ts"
export * from "./ElementsForms.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14db6736",
  null
  
)

export default component.exports